import script from "./CategoryTableActions.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryTableActions.vue?vue&type=script&setup=true&lang=js"

import "./CategoryTableActions.vue?vue&type=style&index=0&id=482f2234&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-482f2234"]])

export default __exports__